/**
 * user_type：
 * developer
 * manager 管理員
 * admin 行政
 * 
 * tutor 職員
 * beautician 美容師
 * consultant 顧問
 * front 前台
 * accountant 會計
 * student 客戶
 */

export const cannotAccessList = {
  'Dashboard': ['tutor', 'beautician', 'consultant', 'front', 'student'],

  'PayTuitionList': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'PayTuitionPayment': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],

  'Timetable': ['student'],
  'CreateAppointment': ['accountant', 'student'],
  'AppointmentDetails': ['accountant', 'student'],

  'CustomerList': ['student'],
  'CreateCustomer': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CustomerDetails': ['student'],
  'CustomerAttendance': ['student'],
  'CustomerUserDetails': ['developer', 'manager', 'admin', 'tutor', 'beautician', 'consultant', 'front', 'accountant'],
  'CustomerUserAttendance': ['developer', 'manager', 'admin', 'tutor', 'beautician', 'consultant', 'front', 'accountant'],

  'ServiceList': ['student'],
  'ServiceDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreateService': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'ServiceCategoryList': ['student'],
  'CreateServiceCategory': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'ServiceCategoryDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'GeneralServiceCategoryList': ['student'],
  'CreateGeneralServiceCategory': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'GeneralServiceCategoryDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],

  'OrderList': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CustomerUserOrderList': ['developer', 'manager', 'admin', 'tutor', 'beautician', 'consultant', 'front', 'accountant'],

  'ProductList': ['student'],
  'ProductDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreateProduct': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'ProductCategoryList': ['student'],
  'CreateProductCategory': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'ProductCategoryDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],

  'PackageList': ['student'],
  'PackageDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreatePackage': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'PackageCategoryList': ['student'],
  'PackageCategoryDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreatePackageCategory': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],

  'RoomList': ['student'],
  'RoomDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreateRoom': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CenterList': ['student'],
  'CenterDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreateCenter': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'StaffList': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'StaffDetails': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'CreateStaff': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
  'Setting': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'],
 
  'Report': ['tutor', 'beautician', 'consultant', 'front', 'student'],

  'AgreementList': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'CreateAgreement': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'AgreementDetails': ['tutor', 'beautician', 'consultant', 'front', 'student'],

  'ShiftCode': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'CreateShiftCode': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'ShiftCodeDetails': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'ShiftControl': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'ShiftStaffCount': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'ShiftHourCount': ['tutor', 'beautician', 'consultant', 'front', 'student'],
  'DailyShiftHour': ['tutor', 'beautician', 'consultant', 'front', 'student'],

  // action
  'editAppointment': ['accountant', 'student'], // create booking/取消預約/修改出席狀態/edit booking
  'newPayment': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 新增繳費
  'approveOrder': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 審核付款
  'editUser': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // edit & create customer
  'refund': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 退款
  'voidOrder': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 作廢發票
  'editOrder': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // edit order remark
  'extendMonthPackage': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 延長月票
  'deductMonthPackage': ['tutor', 'beautician', 'consultant', 'front', 'accountant', 'student'], // 縮短月票
}

export const defaultPage = {
  developer: '/dashboard',
  manager: '/dashboard',
  admin: '/dashboard',
  tutor: '/timetable',
  beautician: '/timetable',
  consultant: '/timetable',
  front: '/timetable',
  accountant: '/timetable',
  student: '/customer-info'
}
